/**
 * Reduced motion utilities for accessibility
 * Respects user's prefers-reduced-motion system preference
 */

/**
 * Check if the user prefers reduced motion
 * @returns {boolean} true if user has enabled reduced motion preference
 */
export function prefersReducedMotion() {
  return window.matchMedia('(prefers-reduced-motion: reduce)').matches
}

/**
 * Get animation duration based on user's motion preference
 * Returns 0 if reduced motion is preferred, otherwise returns the provided duration
 * @param {number} duration - The animation duration in milliseconds
 * @returns {number} The duration to use (0 if reduced motion, otherwise the original duration)
 */
export function getAnimationDuration(duration) {
  return prefersReducedMotion() ? 0 : duration
}
